import { Link } from 'react-router';
import React, { PropTypes } from 'react';

const NavLink = ({
    link,
    text,
    onClick = () => {}
  }) => (
  <li>
    <Link to={link}>{text}</Link>
  </li>
)

NavLink.PropTypes = {
  link: PropTypes.string,
  text: PropTypes.string,
}

export default NavLink;



// WEBPACK FOOTER //
// ./src/components/Navbar/NavLink.jsx